import { Product } from '@app/core/model/product';
import { isInRange } from '@app/utils/date.utils';

export const getCurrentCommercialYear = (
  commercialYears: Product[],
): Product | undefined =>
  (commercialYears || []).find((cy) =>
    cy.meta.period?.startDate && cy.meta.period?.endDate
      ? isInRange(cy.meta.period.startDate, cy.meta.period.endDate, new Date())
      : false,
  );
